/**
 * The warning shown before an archived job is restored while Intacct still has it
 * marked Completed.
 *
 * The Project Tracker archives a job on its own once Intacct's Job status reads
 * Completed. A restore sticks — the nightly sync will not archive the job again —
 * which means the job now stays on the active Projects list until someone archives
 * it by hand. Nothing else says so, so the button does, before it acts.
 *
 * Only when there is something to warn about: a job that is not archived has no
 * restore, and a job Intacct does not call Completed was never going to be
 * archived automatically.
 *
 * `intacctJobCompleted` is decided by the API (the one place that knows what counts
 * as Completed), so this does not carry a second copy of that rule.
 */
export interface RestoreWarningProject {
  jobNumber: string;
  isArchived: boolean;
  intacctJobCompleted?: boolean;
}

export function restoreWarning(project: RestoreWarningProject): string | null {
  if (!project.isArchived || !project.intacctJobCompleted) return null;
  return (
    `Intacct shows job #${project.jobNumber} as Completed.\n\n`
    + 'If you restore it, the Project Tracker will not archive it automatically again. '
    + 'It will stay on the active Projects list until someone archives it by hand.\n\n'
    + 'Restore it anyway?'
  );
}
